import {HCFALine} from "@/core/entity/HCFALine";

export const ENDPOINT = {
  LOGIN: '/user/login',
  VERIFY: '/user/verify',
  PROFILE: "/user/me",
  PRODUCT: "/product",
  POLICY: "/policy",
  CASE: "/case",
  LOCATION: "/location",
  COMPANY: '/company',
  USER: "/user",
  ACTIVITY: "/activity",
  NOTE: "/note",
  DOCUMENT: "/document",
  CONTACT: "/contact",
  PAYMENT: "/payment",
}


export const POLICY_STATUS = [
  {name: 'Confirmed', value: 'ACTIVE'},
  {name: 'Temporary', value: 'TEMPORARY'},
  {name: 'Not-Confirmed', value: 'NOT_CONFIRMED'},
  {name: 'Canceled', value: 'CANCELED'},
]

export const OPERATOR = {
  EQ: 'eq', // =
  LIKE: 'lk', // like
  IN: 'in',  // in
  GT: 'gt', // >
  LS: 'ls', // <
  GREQ: 'gte', // >-
  LSEQ: 'lte', // <=
  NE: 'ne', // !=
  NUL: 'null',
  NOT_NULL: 'notnull'
}

export const SEARCH_ENTITY = {
  POLICY: 'policy',
  POLICY_VIEW: 'pv',
  CASE_VIEW: 'cv',
  CASE: 'case',
  ACTIVITY: "activity",
  CLAIM_VIEW: "claimView",
}

export const CASE_TYPE = [
  {name: 'Inquiry', value: 'IQ'},
  {name: 'In-patient', value: 'IP'},
  {name: 'Out-patient', value: 'OP'},
  {name: 'TripCan', value: 'TC'},
  {name: 'Baggage', value: 'BG'},
  {name: 'Dental', value: 'DT'},
  {name: 'Other', value: 'OT'},
]

export const CASE_STATUS = [
  {name: 'Active', value: 'ACTIVE', valueName: 'Active'},
  {name: 'Closed', value: 'CLOSED', valueName: 'Closed'},
]
export const TEMPLATE_TYPE = [
  {name: 'Activity', value: 'NOTE'},
  {name: 'Task', value: 'TASK'},
  {name: 'Email', value: 'EMAIL'},
]

export const CONTACT_TYPE = [
  {name: 'Contact', value: 'CONTACT'},
  {name: 'Insured', value: 'INSURED'},
  {name: 'Home Address', value: 'HOME'},
  {name: 'Travel Address', value: 'TRAVEL'},
  {name: 'Family', value: 'FAMILY'},
  {name: 'Friend', value: 'FRIEND'},
  {name: 'Other Insurance', value: 'OTHER_INSURANCE'},
  {name: 'Provider', value: 'PROVIDER'},
]
export const PROVIDER_TYPE = [
  {name: 'Doctor', value: 'DOCTOR'},
  {name: 'Clinic', value: 'CLINIC'},
  {name: 'Hospital', value: 'HOSPITAL'},
  {name: 'Air Ambulance', value: 'AIR_AMBULANCE'},
  {name: 'Ground Ambulance', value: 'GROUND_AMBULANCE'},
  {name: 'Other', value: 'OTHER'},
]

export const INSURED_TYPE = [
  {name: 'Insured', value: 'INSURED'},
  {name: 'Primary', value: 'PRIMARY'},
  {name: 'Spouse', value: 'SPOUSE'},
  {name: 'Child', value: 'CHILD'},
  {name: 'Member', value: 'MEMBER'},
]
export const INSURED_STATUS = [
  {name: 'Active', value: 'ACTIVE'},
  {name: 'Canceled', value: 'CANCELED'},
]
export const ACTIVITY_TYPE = [
  {name: 'Phone Call (IN)', value: 'CALL_IN'},
  {name: 'Phone Call (OUT)', value: 'CALL_OUT'},
  {name: 'Reserve Update', value: 'RESERVE'},
  {name: 'Inquiry Status', value: 'INQ_ST'},
  {name: 'Medical Review', value: 'CMR'},
  {name: 'Case Review', value: 'CR'},
  {name: 'Coverage Confirmation', value: 'CC'},
  {name: 'Verification of Benefits', value: 'VB'},
  {name: 'Note ', value: 'NOTE'},
  {name: 'Email (Received) ', value: 'EMAIL_RECEIVED'},
  {name: 'Email (Sent)', value: 'EMAIL_OUT'},
]
export const ACTIVITY_STATUS = [
  {name: 'Completed', value: 'DONE'},
  {name: 'Active', value: 'ACTIVE'},
  {name: 'Pending', value: 'PENDING'},
  {name: 'Not Required', value: 'CANCELED'},
]

export const CURRENCY = [
  'CAD', 'USD', 'EUR', 'GBP', 'MXN', 'CUP', 'AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BTC', 'BTN', 'BWP', 'BYN', 'BYR', 'BZD', 'CDF', 'CHF', 'CLF', 'CLP', 'CNY', 'COP', 'CRC', 'CUC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EEK', 'EGP', 'ERN', 'ETB', 'FJD', 'FKP', 'GEL', 'GGP', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'IMP', 'INR', 'IQD', 'IRR', 'ISK', 'JEP', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LTL', 'LVL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'STD', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'UYU', 'UZS', 'VEF', 'VND', 'VUV', 'WST', 'XAF', 'XAG', 'XAU', 'XCD', 'XDR', 'XOF', 'XPF', 'YER', 'ZAR', 'ZMK', 'ZMW', 'ZWL', 'VES'
]


export const COOKIE_KEY = {
  RECENT_POLICIES: 'RECENT_POLICIES',
  RECENT_CASES: 'RECENT_CASES',
  RECENT_CLAIMS: 'RECENT_CLAIMS',
  RECENT_INVOICES: "RECENT_INVOICES",
  RECENT_PAYMENTS: "RECENT_PAYMENTS",
  THEME: "THEME",
  IMPERSONAL: "IMPERSONAL"
}

export const PROVIDER_STATUS = [
  {name: 'Active', value: 'ACTIVE'},
  {name: 'Completed', value: 'COMPLETED'},
]

export const UB04_LINE = {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0};
export const UB04_LINES = [
  {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0},
  {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0},
  {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0},
  {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0},
  {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0},
  {type: 'UB04', rev: '', desc: '', cpt: '', modifier: '', fromDt: NaN, units: 0, amount: 0},
]
export const PRESCRIPT = {type: 'PRESCRIPT'}
export const TRIP_CAN = {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0}
export const TRIP_CANS = [
  {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0},
  {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0},
  {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0},
  {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0},
  {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0},
  {type: 'TRIP_CAN', desc: '', amount: 0, refund: 0, offerBy: '', outstandingAmount: 0},
]
export const LOST_BAG = {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''}

export const LOST_BAGS = [
  {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''},
  {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''},
  {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''},
  {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''},
  {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''},
  {type: 'LOST_BAG', desc: '', pos: '', fromDt: NaN, amount: 0, currency: ''},
]

export const HCFA_LINE = {
  type: 'HCFA',
  fromDt: NaN,
  toDt: NaN,
  pos: '',
  emg: '',
  cpt: '',
  modifier: '',
  diagnosis: '',
  units: 0,
  amount: 0
};

export const RESERVE_LINE_TYPE = [
  {name: 'Hospital', value: 'HOSPITAL'},
  {name: 'Physician', value: 'PHYSICIAN'},
  {name: 'Clinic', value: 'CLINIC'},
  {name: 'Air Ambulance', value: 'AIR_AMBULANCE'},
  {name: 'Other Expenses', value: 'OTHER_EXPENSES'},
]

export const RESERVE_LINES = [{
  type: '',
  currency: '',
  value: 0.0,
  valueCAD: 0.0
}]

export const HCFA_LINES = [
  new HCFALine(),
]

export const DOCUMENT_TYPES = [
  {value: 'AA', name: "Air Ambulance"},
  {value: 'APPEAL', name: "Appeal Letter"},
  {value: 'APPLICATION', name: "Application (Insurance)"},
  {value: 'ARPT', name: "Accident Report"},
  {value: 'AUTH', name: "Authorization"},
  {value: 'AUDIO', name: "AUDIO"},
  {value: 'PAYMENT_BATCH', name: "BATCH"},
  {value: 'CA', name: "Collection Agency"},
  {value: 'CHEQUE', name: "Cheque"},
  {value: 'CLAIM_FORM', name: "Claim Form"},
  {value: 'CL', name: "Clarifying Letter - PCP"},
  {value: 'COB', name: "COB Letter"},
  {value: 'COI', name: "Confirmation of Insurance"},
  {value: 'CR', name: "Commercial Repatriation"},
  {value: 'DED', name: "Deductible"},
  {value: 'DEATH_CERT', name: "Death Certificate"},
  {value: 'DISCL', name: "Disclaimer"},
  {value: 'DS', name: "Discharge Summary"},
  {value: 'EOB', name: "EOB"},
  {value: 'FTF', name: "Fit to Fly"},
  {value: 'GHIPF', name: "GHIP Forms"},
  {value: 'GOP', name: "GOP"},
  {value: 'HIPAA', name: "HIPAA"},
  {value: 'IR', name: "Invoice Request"},
  {value: 'KEYFACTS', name: "Keyfacts"},
  {value: 'LAST_WILL', name: "Last Will"},
  {value: 'LETTER', name: "LETTER"},
  {value: 'LEGAL', name: "Legal Letter"},
  {value: 'LL', name: "Lawyer Letter"},
  {value: 'LOBL', name: "Limitation of Benefits"},
  {value: 'MED_DECLARATION', name: "Medical Declaration"},
  {value: 'MEDIF', name: "MEDIF"},
  {value: 'MR', name: "Medical Records"},
  {value: 'MRGP', name: "Medical Records - GP"},
  {value: 'MRF', name: "Medical Release Form"},
  {value: 'MRR', name: "Medical Records Request"},
  {value: 'MVA', name: "Motor Vehicle Accident Benefit/Policy"},
  {value: 'NR', name: "Network Repricing"},
  {value: 'O_INVOICE', name: "Original Invoice"},
  {value: 'OI', name: "Other Insurance"},
  {value: 'OR', name: "Operative Report"},
  {value: 'PASSPORT', name: "Passport"},
  {value: 'PIPEDA', name: "PIPEDA"},
  {value: 'PIR', name: "Property Irregularity Report"},
  {value: 'PLANE_TICKET', name: "Plane Ticket"},
  {value: 'POA', name: "Power of Attorney"},
  {value: 'POLICE_REPORT', name: "Police Report"},
  {value: 'POLICY', name: "Policy Wording"},
  {value: 'POD', name: "Proof of Departure"},
  {value: 'POP', name: "Proof of Payment"},
  {value: 'PREEX', name: "Pre-Ex"},
  {value: 'PROA', name: "Proof of Arrival"},
  {value: 'PROGRESS_NOTE', name: "Progress Note"},
  {value: 'QUOTE', name: "Quote"},
  {value: 'RECS', name: "Receipt"},
  {value: 'RI', name: "Repricing Invoice"},
  {value: 'RPS', name: "Repricing Sheet"},
  {value: 'RX', name: "Prescriptions"},
  {value: 'SPR', name: "Specialists Records"},
  {value: 'STATEMENT', name: "Statement"},
  {value: 'TPL', name: "Third Party Liability"},
  {value: 'VOB', name: "VOB"}
]

export const DOCUMENT_STATUS = [
  {name: 'Received', value: 'RECEIVED'},
  {name: 'Sent', value: 'SENT'},
]

export const PRODUCT_TYPE = [
  {name: 'Group', value: 'GROUP'},
  {name: 'Travel', value: 'TRAVEL'},
]

export const BACKGROUNDS = [
  '/media/backgrounds/1.jpeg',
  '/media/backgrounds/2.jpeg',
  '/media/backgrounds/3.jpeg',
  '/media/backgrounds/4.jpeg',
  '/media/backgrounds/5.jpeg',
  '/media/backgrounds/6.jpeg',
  '/media/backgrounds/7.jpeg',
  '/media/backgrounds/8.jpeg',
  '/media/backgrounds/9.jpeg',
  '/media/backgrounds/10.jpeg',
  '/media/backgrounds/11.png',
  '/media/backgrounds/12.jpeg',
  '/media/backgrounds/13.jpeg',
  '/media/backgrounds/14.jpeg',
  '/media/backgrounds/15.jpeg',
  '/media/backgrounds/16.jpeg',
  '/media/backgrounds/17.jpeg',
  '/media/backgrounds/18.jpeg',
  '/media/backgrounds/19.jpeg',
  '/media/backgrounds/20.jpeg',
]

export const THEME_DEFAULT = [
  {name: 'Light', value: 'rgba(59, 146, 167, 0.1)'},
  {name: 'Dark', value: '#296472'},
]


export enum FieldType {
  TEXT,
  CHECKBOX,
  NUMBER,
  DATETIME,
  SELECT,
  RADIO,
  GROUP,
  INPUT_GROUP,
  TEXTAREA,
}

export enum InvoiceType {
  HCFA = 'HCFA',
  UB04 = 'UB04',
  TRIP_CAN = 'TRIP_CAN',
  PRESCRIPT = 'PRESCRIPT',
  LOST_BAG = 'LOST_BAG',
  DENTAL = 'DENTAL',
  STATEMENT = 'STATEMENT',
  RX = 'RX',
  AETNA = 'AETNA',
  IMED = "IMED"
}

export enum GroupField {
  INPUT_GROUP,
  PROVIDER,
  LINES
}

export enum LookupType {
  CPT = "CPT",
  HCPCS = "HCPCS",
  ICD10CM = "ICD10CM",
  ICD10PCS = "ICD10PCS",
  POS = "POS",
  REV = "REV",
  CPTHCPCS = "CPTHCPCS"
}


export const REPRICE_STATUS = [
  {value: 'TO_REPRICE', name: 'To Reprice'},
  {value: 'NOT_REPRICEABLE', name: 'Not-Repriceable'},
  {value: 'TO_SEND', name: 'To send'},
  {value: 'IN_PROCESS', name: 'In process'},
  {value: 'REPRICED', name: 'Repriced'},
]


export const ADJUDICATE_STATUS = [
  {value: 'TO_ADJUDICATE', name: 'To Adjudicate'},
  {value: 'PENDING', name: 'Pending'},
  {value: 'NONE_PAYABLE', name: 'Denied'},
  {value: 'INELIGIBLE', name: 'Ineligible'},
  {value: 'ADJUDICATED', name: 'Payable'},
]


export const ADJUDICATE_TYPE = [
  {value: 'INELIGIBLE', name: 'Ineligible'},
  {value: 'DEDUCTIBLE', name: 'Deductible'},
  {value: 'COINSURANCE', name: 'Coinsurance'},
  {value: 'COPAY', name: 'Copay'},
  {value: 'OTHER_INSURANCE', name: 'Other Insurance'},
  {value: 'CLIENT_RESPONSIBILITY', name: 'Client Responsibility'},
  {value: 'CLIENT_PAID', name: 'Client Paid'},
]


export const PAYMENT_SUB_TYPE = [
  {value: 'PROVIDER', name: 'Provider'},
  {value: 'PATIENT', name: 'Patient'},
  {value: 'OTHER', name: 'Other'}
]


export const PAYMENT_METHOD = [
  {value: 'CHEQUE', name: 'Cheque'},
  {value: 'WIRE_TRANSFER', name: 'Wire Transfer'},
  {value: 'DIRECT_DEPOSIT', name: 'Direct Deposit'},
]

export const PAYMENT_METHOD_AETNA = [
  {value: 'WIRE_TRANSFER', name: 'Wire Transfer'},
  {value: 'CHEQUE', name: 'Cheque'},
  {value: 'DIRECT_DEPOSIT', name: 'Direct Deposit'},
  {value: 'TRANSFER', name: 'Transfer'}
]
export const PAYMENT_STATUS = [
  {value: 'PENDING', name: 'Pending'},
  {value: 'PAYABLE', name: 'Payable'},
  {value: 'PAID', name: 'Paid'},
]

export const PAYMENT_STATUS_PENDING = [
  {value: 'PENDING', name: 'Pending'},
]

// payment.direction: 0 = outbound (we pay), 1 = inbound (refund, money flowing back to the claim)
export const PAYMENT_DIRECTION = {
  OUTBOUND: 0,
  INBOUND: 1,
}

export const REFUND_CATEGORY = [
  {value: 'REFUND', name: 'Refund'},
  {value: 'SUBROGATION', name: 'Subrogation'},
  {value: 'DEDUCTIBLE', name: 'Deductible'},
]

// same stored statuses as PAYMENT_STATUS, worded for money coming in
export const REFUND_STATUS = [
  {value: 'PENDING', name: 'Pending'},
  {value: 'PAYABLE', name: 'Receivable'},
  {value: 'PAID', name: 'Received'},
]
export const NOTIFICATION_CODE = [
  {value: 'CASE_CREATE', name: 'Case Created'},
  {value: 'CASE_UPDATE', name: 'Case Update'},
  {value: 'CASE_DELETE', name: 'Case Delete'},
  {value: 'CASE_CLOSED', name: 'Case Closed'},
  {value: 'CASE_REOPEN', name: 'Case Reopen'},
  {value: 'CLAIM_CREATE', name: 'Claim Create'},
  {value: 'CLAIM_UPDATE', name: 'Claim Update'},
  {value: 'CLAIM_CLOSED', name: 'Claim Closed'},
  {value: 'CLAIM_DELETE', name: 'Claim Closed'},
  {value: 'INVOICE_CREATE', name: 'Invoice Create'},
  {value: 'INVOICE_UPDATE', name: 'Invoice Update'},
  {value: 'INVOICE_DELETE', name: 'Invoice Delete'},
  {value: 'PAYMENT_CREATE', name: 'Payment Create'},
  {value: 'PAYMENT_UPDATE', name: 'Payment Update'},
  {value: 'PAYMENT_DELETE', name: 'Payment Delete'},
]

export const NOTIFICATION_TYPE = [
  {value: 'EMAIL', name: 'EMAIL'},
  {value: 'SMS', name: 'SMS'},
  {value: 'BOTH', name: 'Both'},
]

export const BENEFIT_TYPE = [
  {value: 'M', name: 'Medical'},
  {value: 'EH', name: 'Extended health'},
  {value: 'ERH', name: 'Emergency return home'},
  {value: 'TI', name: 'Trip interruption'},
  {value: 'TC', name: 'Trip Cancellation'},
  {value: 'RR', name: 'Repatriation of remains'},
  {value: 'L', name: 'Life'},
  {value: 'DM', name: 'Dismemberment'},
]


export const CM_STATUS = [
  {value: 'ACTIVE', name: 'Active'},
  {value: 'CLOSED', name: 'Closed'},
  {value: 'NOT_REQUIRED', name: 'Not Required'},
]

export const PRIORITY = [
  {value: 'LOW', name: 'Low'},
  {value: 'MEDIUM', name: 'Medium'},
  {value: 'HIGH', name: 'High'},
  {value: 'HIGHEST', name: 'Highest'},
]

export const CLAIM_DOC_STATUS = [
  {name: 'Not Requested', value: 'NOT_REQUESTED'},
  {name: 'Pending', value: 'PENDING'},
  {name: 'Completed', value: 'COMPLETED'},
  {name: 'Not Provided', value: 'NOT_PROVIDED'},
]

export const REMINDER_STATUS = [
  {name: 'Not Set', value: 'NOT_SET'},
  {name: 'Completed', value: 'COMPLETED'},
]

export const CLAIM_DECISION = [
  {name: 'No Decision', value: 'NO_DECISION'},
  {name: 'Payable', value: 'PAYABLE'},
  {name: 'Denied', value: 'DENIED'}
]
export const CLAIM_APPROVAL = [
  {name: 'Not Required', value: 'NOT_REQUIRED'},
  {name: 'Requested', value: 'REQUESTED'},
  {name: 'Approved', value: 'APPROVED'},
  {name: 'Not Approved', value: 'NOT_APPROVED'},
]

export const TAG_COLOR = [
  {name: 'red', hex: "#dc3545"},
  {name: 'blue', hex: "#0d6efd"},
  {name: 'purple', hex: "#6f42c1"},
  {name: 'pink', hex: "#d63384"},
  {name: 'orange', hex: "#fd7e14"},
  {name: 'yellow', hex: "#ffc107"},
  {name: 'green', hex: "#198754"},
  {name: 'teal', hex: "#20c997"},
  {name: 'cyan', hex: "#0dcaf0"},
]

export const PROCESS_TYPE = {
  MEDICAL_REVIEW: {name: 'Medical Review', names: 'Medical Reviews'},
  COMPLAINT: {name: 'Complaint', names: 'Complaints'},
  INQUIRY: {name: 'Inquiry', names: 'Inquiries'},
  APPEAL: {name: 'Appeal', names: 'Appeals'},
  ISSUE: {name: 'Issue', names: 'Issues'},
  ESCALATION: {name: 'Escalation', names: 'Escalations'},
}

export const SERVICE_PAYMENT_STATUS = [
  {value: 'PENDING', name: 'Pending'},
  {value: 'RECEIVABLE', name: 'Receivable'},
  {value: 'RECEIVED', name: 'Received'},
]

export const PERIOD = [
  {value: 'THIS_WEEK', name: 'This Week'},
  {value: 'THIS_MONTH', name: 'This Month'},
  {value: 'THIS_YEAR', name: 'This Year'},
  {value: 'CUSTOM', name: 'Custom'},
]

export const GHIP_PROVINCES = [
  {name: 'Alberta'},
  {name: 'British Columbia'},
  {name: 'Manitoba'},
  {name: 'New Brunswick'},
  {name: 'Newfoundland and Labrador'},
  {name: 'Northwest Territories'},
  {name: 'Nova Scotia'},
  {name: 'Nunavut'},
  {name: 'Ontario'},
  {name: 'Prince Edward Island'},
  {name: 'Quebec'},
  {name: 'Saskatchewan'},
  {name: 'Yukon'},
]


export const CALL_CATEGORY = [
  {value: 'PRE_TRIP', name: 'Pre-Trip'},
  {value: 'DURING_TRIP', name: 'During-Trip'},
  {value: 'POST_TRIP', name: 'Post-Trip'},
  {value: 'INQUIRY', name: 'Inquiry'},
  {value: 'COMPLAINT', name: 'Complaint'},
  {value: 'OTHER', name: 'Other'},
]

export const ChartCode = {
  CALLS_IN_TILE: 'CALLS_IN_TILE',
  CALLS_OUT_TILE: 'CALLS_OUT_TILE',
  CALLS_DUR_TILE: 'CALLS_DUR_TILE',
  CALLS_AUDIT_TILE: 'CALLS_AUDIT_TILE',
  CALLS_CHART: 'CALLS_CHART',
  CALLS_HOUR_CHART: 'CALLS_HOUR_CHART',
  CALLS_MONTH_CHART: 'CALLS_MONTH_CHART',
  CALLS_DUR_CHART: 'CALLS_DUR_CHART',
  CALLS_DUR_HOUR_CHART: 'CALLS_DUR_HOUR_CHART',
  CALLS_CLIENT_SUMMARY_CHART: 'CALLS_CLIENT_SUMMARY_CHART',
  CALLS_CLIENT_CHART: 'CALLS_CLIENT_CHART',

  CASES_CM_IP_TILE: 'CASES_CM_IP_TILE',
  CASES_CM_OP_TILE: 'CASES_CM_OP_TILE',
  CASES_CM_HOSP_TILE: 'CASES_CM_HOSP_TILE',
  CASES_CM_HOSP_US_TILE: 'CASES_CM_HOSP_US_TILE',
  CASES_CM_HOSP_WORLD_TILE: 'CASES_CM_HOSP_WORLD_TILE',
  STATS_CASES_CM_IP: 'STATS_CASES_CM_IP',
  STATS_CASES_CM_OP: 'STATS_CASES_CM_OP',
  STATS_IP_HOSPITALIZATION: 'STATS_IP_HOSPITALIZATION',
  CASES_CM_PRIORITY_CHART: 'CASES_CM_PRIORITY_CHART',
  CASES_HOSPITALIZATION_TABLE: 'CASES_HOSPITALIZATION_TABLE',
  CASES_HOSPITALIZATION_MONTH_CHART: 'CASES_HOSPITALIZATION_MONTH_CHART',
  CASES_HOSPITALIZATION_MONTH_TABLE: 'CASES_HOSPITALIZATION_MONTH_TABLE', // # hospitalizations and avg stay by month
  CASES_HOSPITALIZATION_COUNTRY: 'CASES_HOSPITALIZATION_COUNTRY', // # hospitalizations by country
  CLAIMS_ACTIVE_TILE: 'CLAIMS_ACTIVE_TILE',  // number of active  claims
  CLAIMS_FAST_TRACK_TILE: 'CLAIMS_FAST_TRACK_TILE', // number of active fast track claims
  CLAIMS_PENDING_DOC_TILE: 'CLAIMS_PENDING_DOC_TILE', // number of active claims pending documents
  CLAIMS_WITH_DECISION_TILE: 'CLAIMS_WITH_DECISION_TILE', // number of active claims with decision
  CLAIMS_CREATED_CHART: 'CLAIMS_CREATED_CHART', // claims created by day
  CLAIMS_CLOSED_CHART: 'CLAIMS_CLOSED_CHART', // claims closed by day
  CLAIMS_EVENTS_MONTH: 'CLAIMS_EVENTS_MONTH', // claim event months
  STATS_CLAIMS_ACTIVE: 'STATS_CLAIMS_ACTIVE', // active claims by day
  CLAIMS_PENDING_DOC_AGE_CHART: 'CLAIMS_PENDING_DOC_AGE_CHART', // claims pending documents by age (months)
  CLAIMS_WAIT_DECISION_TILE: 'CLAIMS_WAIT_DECISION_TILE', // number of active claims waiting decision
  STATS_CLAIMS_PENDING_DOC: 'STATS_CLAIMS_PENDING_DOC', // claims pending documents by day
  CLAIMS_CREATED_TITLE: 'CLAIMS_CREATED_TITLE', // claims created tile
  CLAIMS_CLOSED_TITLE: 'CLAIMS_CLOSED_TITLE', // claims closed tile

  CLAIMS_RESERVE_TILE: 'CLAIMS_RESERVE_TILE', // total reserve amount outstanding
  STATS_CLAIMS_RESERVE: 'STATS_CLAIMS_RESERVE', // reserve amount by day


  SCANS_SUMMARY_TABLE: 'SCANS_SUMMARY_TABLE', // scans summary table

  CASES_MANAGER_LOAD_14D: 'CASES_MANAGER_LOAD_14D',
  ACTIVITY_DURATION_TEAM_DT: 'ACTIVITY_DURATION_TEAM_DT',
  ACTIVITY_SYSTEM_TEAM_DT: 'ACTIVITY_SYSTEM_TEAM_DT'

}

export const ChartType = {
  TILE: 'tile',
  PIE: 'pie',
  COLUMN: 'column',
  TABLE: 'table',
  TABLE_2: 'table_2',
  DATA_TABLE: 'data_table',
}


export const DOCUMENT_TYPES_FR = [

  {value: 'CLAIM_FORM', name: "Formulaire de réclamation"},
  {value: 'RECS', name: "Reçu"},
  {value: 'POD', name: "Preuve de départ"},
  {value: 'POP', name: "Preuve de paiement"},
  {value: 'MR', name: "Dossiers médicaux"},
];

export const DOCUMENT_TYPES_EN = [
  {value: 'CLAIM_FORM', name: "Claim Form"},
  {value: 'RECS', name: "Receipt"},
  {value: 'POD', name: "Proof of Departure"},
  {value: 'POP', name: "Proof of Payment"},
  {value: 'MR', name: "Medical Records"},
]

export const DOCUMENT_TYPES_FR_FULL = [
  {value: 'AA', name: "Ambulance Aérienne"},
  {value: 'APPEAL', name: "Lettre d'Appel"},
  {value: 'APPLICATION', name: "Demande (Assurance)"},
  {value: 'ARPT', name: "Rapport d'Accident"},
  {value: 'AUTH', name: "Autorisation"},
  {value: 'AUDIO', name: "AUDIO"},
  {value: 'PAYMENT_BATCH', name: "LOT"},
  {value: 'CA', name: "Agence de Recouvrement"},
  {value: 'CHEQUE', name: "Chèque"},
  {value: 'CLAIM_FORM', name: "Formulaire de Réclamation"},
  {value: 'CL', name: "Lettre de Clarification - PCP"},
  {value: 'COB', name: "Lettre de Coordination des Prestations"},
  {value: 'COI', name: "Confirmation d'Assurance"},
  {value: 'CR', name: "Rapatriement Commercial"},
  {value: 'DED', name: "Franchise"},
  {value: 'DEATH_CERT', name: "Certificat de Décès"},
  {value: 'DISCL', name: "Clause de Non-responsabilité"},
  {value: 'DS', name: "Résumé de Sortie"},
  {value: 'EOB', name: "Explication des Prestations"},
  {value: 'FTF', name: "Aptitude à Voler"},
  {value: 'GHIPF', name: "Formulaires GHIP"},
  {value: 'GOP', name: "Garantie de Paiement"},
  {value: 'HIPAA', name: "HIPAA"},
  {value: 'IR', name: "Demande de Facture"},
  {value: 'KEYFACTS', name: "Faits Essentiels"},
  {value: 'LAST_WILL', name: "Testament"},
  {value: 'LETTER', name: "LETTRE"},
  {value: 'LEGAL', name: "Lettre Légale"},
  {value: 'LL', name: "Lettre d'Avocat"},
  {value: 'LOBL', name: "Limitation des Prestations"},
  {value: 'MED_DECLARATION', name: "Déclaration Médicale"},
  {value: 'MEDIF', name: "MEDIF"},
  {value: 'MR', name: "Dossiers Médicaux"},
  {value: 'MRF', name: "Formulaire de Consentement Médical"},
  {value: 'MRR', name: "Demande de Dossiers Médicaux"},
  {value: 'MVA', name: "Bénéfice/Police d'Accident de Véhicule à Moteur"},
  {value: 'NR', name: "Réévaluation Réseau"},
  {value: 'O_INVOICE', name: "Facture Originale"},
  {value: 'OI', name: "Autre Assurance"},
  {value: 'OR', name: "Rapport Opératoire"},
  {value: 'PASSPORT', name: "Passeport"},
  {value: 'PIPEDA', name: "PIPEDA"},
  {value: 'PIR', name: "Rapport d'Irregularité de Propriété"},
  {value: 'PLANE_TICKET', name: "Billet d'Avion"},
  {value: 'POA', name: "Procuration"},
  {value: 'POLICE_REPORT', name: "Rapport de Police"},
  {value: 'POLICY', name: "Conditions de la Police"},
  {value: 'POD', name: "Preuve de Départ"},
  {value: 'POP', name: "Preuve de Paiement"},
  {value: 'PREEX', name: "Pré-Ex"},
  {value: 'PROGRESS_NOTE', name: "Note de Suivi"},
  {value: 'QUOTE', name: "Devis"},
  {value: 'RECS', name: "Reçu"},
  {value: 'RI', name: "Facture de Réévaluation"},
  {value: 'RPS', name: "Feuille de Réévaluation"},
  {value: 'RX', name: "Ordonnances"},
  {value: 'SPR', name: "Dossiers de Spécialistes"},
  {value: 'STATEMENT', name: "Déclaration"},
  {value: 'TPL', name: "Responsabilité Civile"},
  {value: 'VOB', name: "Vérification des Prestations"}
];


export const INVOICE_TYPES = [
  {value: 'HCFA', name: 'HCFA'},
  {value: 'UB04', name: 'UB04'}
]

export const ACTION_TYPES = [
  {value: 'NOTIFICATION', name: 'Notification'},

  {value: 'VIEW_POLICY', name: 'Viewed Policy'},
  {value: 'POLICY_CREATE', name: 'Created policy'},
  {value: 'POLICY_UPDATE', name: 'Updated policy'},
  {value: 'POLICY_DELETE', name: 'Deleted policy'},

  {value: 'VIEW_CASE', name: 'Viewed case'},
  {value: 'CASE_CREATE', name: 'Created case'},
  {value: 'CASE_UPDATE', name: 'Update case'},
  {value: 'CASE_CLOSE', name: 'Closed case'},
  {value: 'CASE_RESERVE', name: 'Updated reserve'},
  {value: 'CASE_DELETE', name: 'Deleted case'},
  {value: 'CASE_MOVE', name: 'Move case'},

  {value: 'VIEW_CLAIM', name: 'Viewed claim'},
  {value: 'CLAIM_CREATE', name: 'Created claim'},
  {value: 'CLAIM_UPDATE', name: 'Updated claim'},
  {value: 'CLAIM_RESERVE', name: 'Updated reserve'},
  {value: 'CLAIM_CLOSE', name: 'Closed claim'},
  {value: 'CLAIM_DELETE', name: 'Deleted claim'},
  {value: 'CLAIM_MOVE', name: 'Moved claim'},

  {value: 'VIEW_INVOICE', name: 'Viewed invoice'},
  {value: 'INVOICE_CREATE', name: 'Created invoice'},
  {value: 'INVOICE_UPDATE', name: 'Updated invoice'},
  {value: 'INVOICE_REPRICE', name: 'Repriced invoice'},
  {value: 'INVOICE_ADJUDICATE', name: 'Adjudicated invoice'},
  {value: 'INVOICE_CLOSED', name: 'Closed invoice'},
  {value: 'INVOICE_FINALIZED', name: 'Finalized invoice'},
  {value: 'INVOICE_DELETE', name: 'Deleted invoice'},
  {value: 'INVOICE_MOVE', name: 'Moved invoice'},
  {value: 'INVOICE_RE_ACTIVATE', name: 'Re-activate invoice'},

  {value: 'PAYMENT_CREATE', name: 'Created payment'},
  {value: 'PAYMENT_UPDATE', name: 'Updated payment'},
  {value: 'PAYMENT_PAID', name: 'Paid payment'},
  {value: 'PAYMENT_DELETE', name: 'Deleted payment'},

  {value: 'ACTIVITY_CREATE', name: 'Created activity'},
  {value: 'ACTIVITY_UPDATE', name: 'Updated activity'},
  {value: 'ACTIVITY_DELETE', name: 'Deleted activity'},
  {value: 'ACTIVITY_CALL_IN', name: 'Received call'},
  {value: 'ACTIVITY_CALL_OUT', name: 'Made call'},

  {value: 'VIEW_DOCUMENT', name: 'Viewed document'},
  {value: 'DOCUMENT_CREATE', name: 'Uploaded document'},
  {value: 'DOCUMENT_UPDATE', name: 'Updated document'},
  {value: 'DOCUMENT_DELETE', name: 'Deleted document'},
  {value: 'DOCUMENT_AUDIO', name: 'Uploaded phone call'},
  {value: 'DOWNLOAD_DOCUMENT', name: 'Downloaded document'},

  {value: 'CASE_PROVIDER_CREATE', name: 'Created case provider'},
  {value: 'CASE_PROVIDER_UPDATE', name: 'Update case provider'},
  {value: 'CASE_PROVIDER_DELETE', name: 'Deleted case provider'},
  {value: 'CASE_PROVIDER_COMPLETE', name: 'Completed case provider'},

  {value: 'CONTACT_CREATE', name: 'Created contact'},
  {value: 'CONTACT_UPDATE', name: 'Updated contact'},
  {value: 'CONTACT_DELETE', name: 'Deleted contact'},

  {value: 'TASK_CREATE', name: 'Created task'},
  {value: 'TASK_UPDATE', name: 'Updated task'},
  {value: 'TASK_DELETE', name: 'Deleted task'},
  {value: 'COMPLETED_TASK', name: 'Completed task'},

  {value: 'REMINDER_CREATE', name: 'Created reminder'},
  {value: 'REMINDER_UPDATE', name: 'Updated reminder'},
  {value: 'REMINDER_DELETE', name: 'Deleted reminder'},
  {value: 'COMPLETED_REMINDER', name: 'Completed reminder'},

  {value: 'ADD_TAG', name: 'Added tag'},
  {value: 'REMOVE_TAG', name: 'Removed tag'},

  {value: 'PROCESS_CREATE', name: 'Created process'},
  {value: 'PROCESS_UPDATE', name: 'Update process'},
  {value: 'PROCESS_COMPLETE', name: 'Completed process'},
  {value: 'DELETE_PROCESS', name: 'Deleted process'},

  {value: 'REPORT_CREATE', name: 'Created report'},
  {value: 'REPORT_UPDATE', name: 'Updated report'},
  {value: 'REPORT_DELETE', name: 'Deleted report'},
  {value: 'FORM_UPDATE', name: 'Form Update'},
]